import { Divider } from "@mui/material";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import SearchIcon from "@mui/icons-material/Search";
import { format, utcToZonedTime } from 'date-fns-tz';
import { parseISO } from 'date-fns';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};


const InfoOrderModal = (props) => {

    let order = props.order[0];
    let client = props.order[0]?.ordersDetail[0]?.productPrice?.client

    return (

        <Modal
            open={props.openModalOrder}
            onClose={props.handleCloseModalOrder}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                        <strong></strong>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '20%' }}>
                        <Button size='small' onClick={props.handleCloseModalOrder}>Cerrar</Button>
                        <Button size='small' onClick={() => props.editOrder(order)}>Editar</Button>
                        <Button size='small' onClick={() => props.deleteOrder(order.uuid)}>Eliminar</Button>

                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Número de orden: </span>
                    <span>{order?.id}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Fecha de orden: </span>
                    <span>
                        {order.date_created
                            ? format(utcToZonedTime(parseISO(order.date_created), 'UTC'), 'dd-MM-yyyy')
                            : 'Sin fecha'}
                    </span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Fecha de entrega: </span>
                    <span>
                        {order.date_delivery
                            ? format(utcToZonedTime(parseISO(order.date_delivery), 'UTC'), 'dd-MM-yyyy')
                            : 'INMEDIATA'}
                    </span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Cliente: </span>
                    <span>{client ? client.name : 'Sin Cliente'}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Código: </span>
                    <span>{client ? client.cod : 'Sin Cliente'}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>NIT: </span>
                    <span>{client ? client.identification : 'Sin Cliente'}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Orden de compra: </span>
                    <span>{order ? order.purchase_order : 'Sin orden de compra'}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '15px' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Dirección de envío: </span>
                    <span>{order?.address_delivery}</span>
                </div>

                <Divider />
                {
                    order?.ordersDetail?.length === 0 ? (
                        <>No hay detalle</>
                    ) : (
                        <div style={{ width: '100%', marginTop: '10px' }}>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                <div style={{ width: '20%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Producto</div>
                                <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Color</div>
                                <div style={{ width: '20%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Cantidad</div>
                                <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Medida</div>
                                <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Precio</div>
                                <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Pendiente</div>
                                <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Reservado</div>
                                <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Despachado</div>
                                <div style={{ width: '20%', fontSize: '10px', fontWeight: 'bold', marginBottom: '10px' }}>Acciones</div>
                            </div>
                            <Divider />
                            <div style={{ width: '100%', overflowY: 'auto', height: '300px' }}>
                                {

                                    order?.ordersDetail?.map((d, key) => {
                                        return (
                                            <div key={key} style={{ width: '100%' }}>
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                                    <div style={{ width: '20%', fontSize: '10px', fontWeight: 'bold', marginTop: '10px' }}>{d?.productPrice?.product ? d?.productPrice?.product?.ref : ""}</div>
                                                    <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginTop: '10px' }}>{d?.color?.cod}</div>
                                                    <div style={{ width: '20%', fontSize: '10px', fontWeight: 'bold', marginTop: '10px' }}>{d?.quantity}</div>
                                                    <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginTop: '10px' }}>{d?.type_quantity}</div>
                                                    <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginTop: '10px' }}>{d?.price}</div>
                                                    <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginTop: '10px' }}>{d?.quantity - d?.total_remi - d?.total_desp - d?.total_fact}</div>
                                                    <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginTop: '10px' }}>{d?.total_desp}</div>
                                                    <div style={{ width: '15%', fontSize: '10px', fontWeight: 'bold', marginTop: '10px' }}>{d?.total_remi}</div>
                                                    <div style={{ width: '20%', fontSize: '10px', fontWeight: 'bold' }}>
                                                        <IconButton size='small' color="primary" onClick={() => {
                                                            props.searchCutInfo(d?.uuid_details);
                                                        }}>
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </div>

                                                </div>
                                                <Divider />
                                            </div>
                                        )
                                    })

                                }
                            </div>
                        </div>
                    )
                }
                <Divider />
                <Divider />
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <span style={{ fontWeight: 'bold', marginRight: '10px' }}>Nota: </span>
                    <span>{order?.notes}</span>
                </div>
            </Box>
        </Modal>

    );
}

export default InfoOrderModal;
